<template>
  <base-layout v-if="user">
    <div class="main ion-padding-horizontal">
      <ion-text>Page not found</ion-text>
    </div>
  </base-layout>  
</template>

<script setup lang="ts">
import BaseLayout from "@/modules/General/components/BaseLayout.vue";
import { IonText } from "@ionic/vue";
import { computed, onBeforeMount } from "vue";
import router from "@/router";
import { RouteNamesEnum } from "@/const/routes";
import { useUserStore } from "../store/userStore";

const user = computed(() => useUserStore()?.user);
onBeforeMount(() => {
  if(!user.value) {
    router.push({name: RouteNamesEnum.Login})
  }
})
</script>

<style lang="scss" scoped>
.main {
  height: calc(100vh - (160px + var(--ion-safe-area-top) + 30px));
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-text {
  font-size: 18px;
  line-height: 21px;
  color: var(--ion-color-dark-grey);
}
</style>